__turbopack_context__.v({
  "accordion-content": "f9jjkq_accordion-content",
  "accordion-item": "f9jjkq_accordion-item",
  "calculator-content": "f9jjkq_calculator-content",
  "calculator-input-row": "f9jjkq_calculator-input-row",
  "label": "f9jjkq_label",
  "modal-box-cta": "f9jjkq_modal-box-cta",
  "modal-content": "f9jjkq_modal-content",
  "placeholder": "f9jjkq_placeholder",
});
